import { forward, sample } from 'effector'

import { fetchCitiesFx, getValidCityFromStorageFx, userSelectedCity } from './units'

sample({
  clock: fetchCitiesFx.doneData.map((data) => data.cities),
  target: getValidCityFromStorageFx
})

forward({
  from: getValidCityFromStorageFx.doneData,
  to: userSelectedCity
})

sample({
  clock: getValidCityFromStorageFx.fail,
  fn: () => [],
  target: userSelectedCity
})
